/**
 * OneTrust 쿠키 카테고리 ID
 * @see https://hpcnt.slack.com/archives/C02SQS5AJDR/p1721787596203649?thread_ts=1721200084.084569&cid=C02SQS5AJDR
 */
export const ONETRUST_COOKIE_CATEGORY = {
  STRICTLY_NECESSARY: '1',
  PERFORMANCE: '2',
  FUNCTIONAL: '3',
  TARGETING: '4',
} as const;

/**
 * 유저가 특정 쿠키 카테고리에 동의했는지 여부를 반환한다.
 *
 * @remarks
 * `window.OptanonActiveGroups`는 ",1,2,3,H400,…," 형태의 문자열로 내려오므로 오탐을 방지하기 위해 `split` 후 비교한다.
 */
export const isCookieCategoryConsented = (categoryId: string): boolean => {
  return (window.OptanonActiveGroups || '').split(',').includes(categoryId);
};

/**
 * OneTrust SDK 초기화 및 consent 변경 시 실행될 콜백을 등록한다.
 *
 * @remarks
 * - `OptanonWrapper`는 OneTrust SDK 초기화 및 consent 변경 시 호출되는 콜백이다.
 * - 내부적으로 `OptanonWrapper`를 체이닝하여, 이전에 등록된 콜백을 유실하지 않도록 한다.
 *
 * @see https://my.onetrust.com/s/article/UUID-518074a1-a6da-81c3-be52-bae7685d9c94
 */
export const addConsentCallback = (callback?: () => void) => {
  const prevOptanonWrapper = window.OptanonWrapper;
  window.OptanonWrapper = function () {
    prevOptanonWrapper?.();
    callback?.();
  };
};
